import React, { useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import logo from "../../logo.svg";
import {
  FiHome,
  FiUsers,
  FiUser,
  FiList,
  FiLogOut,
  FiMenu,
  FiX,
  FiUserPlus,
} from "react-icons/fi";

export default function ChannelPartnerLayout() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navItems = [
    { to: "/channelpartner/dashboard", label: "Dashboard", icon: FiHome },
    { to: "/channelpartner/promoters", label: "My Promoters", icon: FiUsers },
    { to: "/channelpartner/providers", label: "Providers", icon: FiUsers },
    { to: "/channelpartner/listings", label: "Listings", icon: FiList },
    // { to: "/channelpartner/certificate", label: "Certificate", icon: FiAward },
    { to: "/channelpartner/profile", label: "Profile", icon: FiUser },
  ];

  const Sidebar = () => (
    <aside className="w-60 text-white flex flex-col bg-gradient-to-b from-gray-900 via-gray-800 to-gray-700">
      <Link
        to="/"
        className="px-4 py-4 flex items-center gap-3 cursor-pointer"
        onClick={() => setSidebarOpen(false)}
      >
        <img src={logo} alt="OnlineIndianMarket" className="h-8 w-8" />
        <span className="text-3xl font-semibold tracking-wide">OIM</span>
      </Link>
      <div className="h-px bg-white/10 mx-4" />

      <nav className="px-3 py-3 space-y-1 overflow-y-auto flex-1">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/channelpartner/dashboard"}
            className={({ isActive }) =>
              `block w-full text-left px-3 py-2 rounded-md transition-colors duration-150 ${
                isActive ? "bg-white/10" : "hover:bg-white/5"
              }`
            }
            onClick={() => setSidebarOpen(false)}
          >
            <span className="flex items-center gap-2">
              <Icon className="h-5 w-5" />
              <span>{label}</span>
            </span>
          </NavLink>
        ))}
      </nav>

      <div className="mt-auto px-3 pb-4 space-y-2">
        <button
          onClick={() => {
            logout();
            navigate("/signin");
          }}
          className="block w-full text-left px-3 py-2 rounded-md text-gray-300 hover:text-white hover:bg-white/5 transition-colors duration-150"
        >
          <span className="flex items-center gap-2">
            <FiLogOut className="h-5 w-5" />
            <span>Logout</span>
          </span>
        </button>
      </div>
    </aside>
  );

  return (
    <div className="flex h-screen poppins-regular bg-gray-50">
      {/* Top navbar (Mobile + Tablet) */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-20 bg-gray-900 text-white flex items-center justify-between px-4 py-3 shadow">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="OnlineIndianMarket" className="h-7 w-7" />
          <span className="text-2xl font-semibold">OIM</span>
        </Link>
        <button onClick={() => setSidebarOpen(!sidebarOpen)}>
          {sidebarOpen ? (
            <FiX className="h-6 w-6" />
          ) : (
            <FiMenu className="h-6 w-6" />
          )}
        </button>
      </div>

      {/* Sidebar for desktop */}
      <div className="hidden lg:flex">
        <Sidebar />
      </div>

      {/* Drawer Sidebar (Mobile + Tablet) */}
      {sidebarOpen && (
        <div className="fixed inset-0 z-30 flex lg:hidden">
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/50"
            onClick={() => setSidebarOpen(false)}
          />
          {/* Sidebar */}
          <div className="relative z-40 transform transition-transform duration-300">
            <Sidebar />
          </div>
        </div>
      )}

      {/* Main content */}
      <main className="flex-1 p-6 overflow-y-auto mt-14 lg:mt-0 relative">
        <Outlet />

        {/* Floating Action Button for Create Promoter */}
        <Link
          to="/channelpartner/create-promoter"
          className="fixed bottom-12 right-6 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-200 z-50 group"
          title="Create Promoter"
        >
          <FiUserPlus className="h-6 w-6" />
          <span className="absolute right-16 top-1/2 transform -translate-y-1/2 bg-gray-900 text-white px-3 py-1 rounded-md text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
            Create Promoter
          </span>
        </Link>
      </main>
    </div>
  );
}
